import { useEffect as t } from "react";
const f = _ref => {
  let {
    open: n,
    onAfterOpen: e
  } = _ref;
  t(() => {
    n && e && e();
  }, [e, n]);
};
export { f as useOnAfterOpen };